const serverRoutes: {
  it: {
    [key: string]: {
      value: string;
      disallow: boolean;
    };
  };
  en: {
    [key: string]: {
      value: string;
      disallow: boolean;
    };
  };
  es: {
    [key: string]: {
      value: string;
      disallow: boolean;
    };
  };
  fr: {
    [key: string]: {
      value: string;
      disallow: boolean;
    };
  };
  de: {
    [key: string]: {
      value: string;
      disallow: boolean;
    };
  };
} = {
  it: {
    'routes.**': {
      value: '**',
      disallow: false,
    },
    'routes.ambassador': {
      value: 'ambassador',
      disallow: false,
    },
    'routes.become-pro': {
      value: 'diventa-pro',
      disallow: false,
    },
    'routes.cherry-meter': {
      value: 'ciliegiometro',
      disallow: false,
    },
    'routes.community': {
      value: 'community',
      disallow: false,
    },
    'routes.community/my-posts': {
      value: 'community/i-miei-post',
      disallow: true,
    },
    'routes.contacts': {
      value: 'contatti',
      disallow: false,
    },
    'routes.content-not-found': {
      value: 'content-not-found',
      disallow: false,
    },
    'routes.create': {
      value: 'crea',
      disallow: true,
    },
    'routes.create?': {
      value: 'crea?',
      disallow: true,
    },
    'routes.dashboard': {
      value: 'dashboard',
      disallow: true,
    },
    'routes.dashboard/bookings': {
      value: 'dashboard/prenotazioni',
      disallow: true,
    },
    'routes.dashboard/calendar': {
      value: 'dashboard/calendario',
      disallow: true,
    },
    'routes.dashboard/user-carts': {
      value: 'dashboard/user-carts',
      disallow: true,
    },
    'routes.dashboard/custom-requests': {
      value: 'dashboard/richieste-su-misura',
      disallow: true,
    },
    'routes.dashboard/messages': {
      value: 'dashboard/messaggi',
      disallow: true,
    },
    'routes.dashboard/notifications': {
      value: 'dashboard/notifiche',
      disallow: true,
    },
    'routes.dashboard/sharry-management': {
      value: 'dashboard/gestione-esperienze',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit': {
      value: 'dashboard/gestione-esperienze/modifica',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit/:id': {
      value: 'dashboard/gestione-esperienze/modifica/:id',
      disallow: true,
    },
    'routes.deprecated': {
      value: 'deprecated',
      disallow: false,
    },
    'routes.edit': {
      value: 'modifica',
      disallow: true,
    },
    'routes.event-dashboard': {
      value: 'dashboard-eventi',
      disallow: true,
    },
    'routes.event-dashboard/events-calendar': {
      value: 'dashboard-eventi/calendario-eventi',
      disallow: true,
    },
    'routes.event-dashboard/events-report': {
      value: 'dashboard-eventi/segnala-eventi',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit': {
      value: 'dashboard-eventi/segnala-eventi/modifica',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit/:id': {
      value: 'dashboard-eventi/segnala-eventi/modifica/:id',
      disallow: true,
    },
    'routes.event': {
      value: 'eventi',
      disallow: false,
    },
    'routes.events': {
      value: 'eventi',
      disallow: false,
    },
    'routes.events/:slug': {
      value: 'eventi/:slug',
      disallow: false,
    },
    'routes.explore': {
      value: 'esplora',
      disallow: false,
    },
    'routes.faq': {
      value: 'assistenza',
      disallow: false,
    },
    'routes.find/events-at': {
      value: 'trova/eventi-a',
      disallow: false,
    },
    'routes.find/events-at/:location': {
      value: 'trova/eventi-a/:location',
      disallow: false,
    },
    'routes.find/events-in': {
      value: 'trova/eventi-in',
      disallow: false,
    },
    'routes.find/events-in/:location': {
      value: 'trova/eventi-in/:location',
      disallow: false,
    },
    'routes.find/what-to-do-at': {
      value: 'trova/cosa-fare-a',
      disallow: false,
    },
    'routes.find/what-to-do-at/:location': {
      value: 'trova/cosa-fare-a/:location',
      disallow: false,
    },
    'routes.find/what-to-do-near': {
      value: 'trova/cosa-fare-vicino',
      disallow: false,
    },
    'routes.find/what-to-do-near/:location': {
      value: 'trova/cosa-fare-vicino/:location',
      disallow: false,
    },
    'routes.find/what-to-do-in': {
      value: 'trova/cosa-fare-in',
      disallow: false,
    },
    'routes.find/what-to-do-in/:location': {
      value: 'trova/cosa-fare-in/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-at': {
      value: 'trova/cosa-vedere-a',
      disallow: false,
    },
    'routes.find/what-to-visit-at/:location': {
      value: 'trova/cosa-vedere-a/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-in': {
      value: 'trova/cosa-vedere-in',
      disallow: false,
    },
    'routes.find/what-to-visit-in/:location': {
      value: 'trova/cosa-vedere-in/:location',
      disallow: false,
    },
    'routes.go': {
      value: 'go',
      disallow: false,
    },
    'routes.go/:slug': {
      value: 'go/:slug',
      disallow: false,
    },
    'routes.instances': {
      value: 'set',
      disallow: true,
    },
    'routes.land': {
      value: 'land',
      disallow: false,
    },
    'routes.like': {
      value: 'raccolte/',
      disallow: true,
    },
    'routes.likes': {
      value: 'raccolte',
      disallow: true,
    },
    'routes.likes/default': {
      value: 'raccolte/default',
      disallow: true,
    },
    'routes.maintenance': {
      value: 'maintenance',
      disallow: false,
    },
    'routes.messages': {
      value: 'messaggi',
      disallow: true,
    },
    'routes.network': {
      value: 'rete',
      disallow: true,
    },
    'routes.not-found': {
      value: 'not-found',
      disallow: false,
    },
    'routes.not-implemented': {
      value: 'non-disponibile',
      disallow: false,
    },
    'routes.notifications': {
      value: 'notifiche',
      disallow: true,
    },
    'routes.privacy': {
      value: 'privacy',
      disallow: false,
    },
    'routes.selling-conditions': {
      value: 'condizioni-vendita',
      disallow: false,
    },
    'routes.profile': {
      value: 'profilo',
      disallow: false,
    },
    'routes.profile/:slug': {
      value: 'profilo/:slug',
      disallow: false,
    },
    'routes.profile/home': {
      value: 'profilo/home',
      disallow: true,
    },
    'routes.recommendation-create-introduction': {
      value: 'nuovo-contenuto-informazioni',
      disallow: false,
    },
    'routes.recommendation-management': {
      value: 'consiglia-meraviglie',
      disallow: true,
    },
    'routes.recommendation-management/edit': {
      value: 'consiglia-meraviglie/modifica',
      disallow: true,
    },
    'routes.recommendation-management/edit/:id': {
      value: 'consiglia-meraviglie/modifica/:id',
      disallow: true,
    },
    'routes.search-results': {
      value: 'cerca',
      disallow: false,
    },
    'routes.category': {
      value: 'categoria',
      disallow: false,
    },
    'routes.category/:category': {
      value: 'categoria/:category',
      disallow: false,
    },
    'routes.sharry': {
      value: 'esperienze',
      disallow: false,
    },
    'routes.sharries': {
      value: 'esperienze',
      disallow: false,
    },
    'routes.sharries/:slug': {
      value: 'esperienze/:slug',
      disallow: false,
    },
    'routes.sharries/:slug/instances/:instanceId': {
      value: 'esperienze/:slug/set/:instanceId',
      disallow: true,
    },
    'routes.sharry-activity': {
      value: 'attivita',
      disallow: true,
    },
    'routes.sharry-activity/bookings': {
      value: 'attivita/prenotazioni',
      disallow: true,
    },
    'routes.sharry-activity/messages': {
      value: 'attivita/messaggi',
      disallow: true,
    },
    'routes.sharry-activity/notifications': {
      value: 'attivita/notifiche',
      disallow: true,
    },
    'routes.sharry-activity/requests': {
      value: 'attivita/richieste',
      disallow: true,
    },
    'routes.sharry-create': {
      value: 'crea-shop',
      disallow: true,
    },
    'routes.signin': {
      value: 'signin',
      disallow: true,
    },
    'routes.terms': {
      value: 'termini',
      disallow: false,
    },
    'routes.trip': {
      value: 'sharryland-viaggi',
      disallow: false,
    },
    'routes.what-is-sharryland': {
      value: 'cos-e-sharryland',
      disallow: false,
    },
    'routes.who-we-are': {
      value: 'chi-siamo',
      disallow: false,
    },
    'routes.wonder': {
      value: 'meraviglie',
      disallow: false,
    },
    'routes.wonders': {
      value: 'meraviglie',
      disallow: false,
    },
    'routes.wonders/:slug': {
      value: 'meraviglie/:slug',
      disallow: false,
    },
    'routes.discover': {
      value: 'scopri',
      disallow: false,
    },
    'routes.discover/:keyword': {
      value: 'scopri/:keyword',
      disallow: false,
    },
    'routes.gift-card': {
      value: 'gift-card',
      disallow: false,
    },
    'routes.added-to-cart': {
      value: 'aggiunto-al-carrello',
      disallow: true,
    },
    'routes.cart': {
      value: 'cart',
      disallow: true,
    },
    'routes.checkout': {
      value: 'checkout',
      disallow: true,
    },
    'routes.wonders-map': {
      value: 'mappa-delle-meraviglie',
      disallow: false,
    },
    'routes.business-trips': {
      value: 'viaggi-per-aziende',
      disallow: false,
    },
    'routes.become-coordinator': {
      value: 'diventa-coordinatore',
      disallow: false,
    },
    'routes.likes/shared/:slug': {
      value: 'raccolta/condivisa/:slug',
      disallow: false,
    },
    'routes.post-widget/:slug': {
      value: 'post-widget/:slug',
      disallow: false,
    },
  },
  en: {
    'routes.**': {
      value: '**',
      disallow: false,
    },
    'routes.ambassador': {
      value: 'ambassador',
      disallow: false,
    },
    'routes.become-pro': {
      value: 'become-pro',
      disallow: false,
    },
    'routes.cherry-meter': {
      value: 'cherry-meter',
      disallow: false,
    },
    'routes.community': {
      value: 'community',
      disallow: false,
    },
    'routes.community/my-posts': {
      value: 'community/my-posts',
      disallow: true,
    },
    'routes.contacts': {
      value: 'contacts',
      disallow: false,
    },
    'routes.content-not-found': {
      value: 'content-not-found',
      disallow: false,
    },
    'routes.create': {
      value: 'create',
      disallow: true,
    },
    'routes.create?': {
      value: 'create?',
      disallow: true,
    },
    'routes.dashboard': {
      value: 'dashboard',
      disallow: true,
    },
    'routes.dashboard/bookings': {
      value: 'dashboard/bookings',
      disallow: true,
    },
    'routes.dashboard/calendar': {
      value: 'dashboard/calendar',
      disallow: true,
    },
    'routes.dashboard/user-carts': {
      value: 'dashboard/user-carts',
      disallow: true,
    },
    'routes.dashboard/custom-requests': {
      value: 'dashboard/custom-requests',
      disallow: true,
    },
    'routes.dashboard/messages': {
      value: 'dashboard/messages',
      disallow: true,
    },
    'routes.dashboard/notifications': {
      value: 'dashboard/notifications',
      disallow: true,
    },
    'routes.dashboard/sharry-management': {
      value: 'dashboard/experiences-management',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit': {
      value: 'dashboard/experiences-management/edit',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit/:id': {
      value: 'dashboard/experiences-management/edit/:id',
      disallow: true,
    },
    'routes.deprecated': {
      value: 'deprecated',
      disallow: false,
    },
    'routes.edit': {
      value: 'edit',
      disallow: true,
    },
    'routes.event-dashboard': {
      value: 'event-dashboard',
      disallow: true,
    },
    'routes.event-dashboard/events-calendar': {
      value: 'event-dashboard/events-calendar',
      disallow: true,
    },
    'routes.event-dashboard/events-report': {
      value: 'event-dashboard/events-report',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit': {
      value: 'event-dashboard/events-report/edit',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit/:id': {
      value: 'event-dashboard/events-report/edit/:id',
      disallow: true,
    },
    'routes.event': {
      value: 'events',
      disallow: false,
    },
    'routes.events': {
      value: 'events',
      disallow: false,
    },
    'routes.events/:slug': {
      value: 'events/:slug',
      disallow: false,
    },
    'routes.explore': {
      value: 'explore',
      disallow: false,
    },
    'routes.faq': {
      value: 'help',
      disallow: false,
    },
    'routes.find/events-at': {
      value: 'find/events-at',
      disallow: false,
    },
    'routes.find/events-at/:location': {
      value: 'find/events-at/:location',
      disallow: false,
    },
    'routes.find/events-in': {
      value: 'find/events-in',
      disallow: false,
    },
    'routes.find/events-in/:location': {
      value: 'find/events-in/:location',
      disallow: false,
    },
    'routes.find/what-to-do-at': {
      value: 'find/what-to-do-at',
      disallow: false,
    },
    'routes.find/what-to-do-at/:location': {
      value: 'find/what-to-do-at/:location',
      disallow: false,
    },
    'routes.find/what-to-do-near': {
      value: 'find/what-to-do-near',
      disallow: false,
    },
    'routes.find/what-to-do-near/:location': {
      value: 'find/what-to-do-near/:location',
      disallow: false,
    },
    'routes.find/what-to-do-in': {
      value: 'find/what-to-do-in',
      disallow: false,
    },
    'routes.find/what-to-do-in/:location': {
      value: 'find/what-to-do-in/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-at': {
      value: 'find/what-to-visit-at',
      disallow: false,
    },
    'routes.find/what-to-visit-at/:location': {
      value: 'find/what-to-visit-at/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-in': {
      value: 'find/what-to-visit-in',
      disallow: false,
    },
    'routes.find/what-to-visit-in/:location': {
      value: 'find/what-to-visit-in/:location',
      disallow: false,
    },
    'routes.go': {
      value: 'go',
      disallow: false,
    },
    'routes.go/:slug': {
      value: 'go/:slug',
      disallow: false,
    },
    'routes.instances': {
      value: 'set',
      disallow: true,
    },
    'routes.land': {
      value: 'land',
      disallow: false,
    },
    'routes.like': {
      value: 'my-collections/',
      disallow: true,
    },
    'routes.likes': {
      value: 'my-collections',
      disallow: true,
    },
    'routes.likes/default': {
      value: 'my-collections/default',
      disallow: true,
    },
    'routes.maintenance': {
      value: 'maintenance',
      disallow: false,
    },
    'routes.messages': {
      value: 'messages',
      disallow: true,
    },
    'routes.network': {
      value: 'network',
      disallow: true,
    },
    'routes.not-found': {
      value: 'not-found',
      disallow: false,
    },
    'routes.not-implemented': {
      value: 'not-implemented',
      disallow: false,
    },
    'routes.notifications': {
      value: 'notifications',
      disallow: true,
    },
    'routes.privacy': {
      value: 'privacy',
      disallow: false,
    },
    'routes.selling-conditions': {
      value: 'selling-conditions',
      disallow: false,
    },
    'routes.profile': {
      value: 'profile',
      disallow: false,
    },
    'routes.profile/:slug': {
      value: 'profile/:slug',
      disallow: false,
    },
    'routes.profile/home': {
      value: 'profile/home',
      disallow: true,
    },
    'routes.recommendation-create-introduction': {
      value: 'recommendation-create-introduction',
      disallow: false,
    },
    'routes.recommendation-management': {
      value: 'wonder-recommend',
      disallow: true,
    },
    'routes.recommendation-management/edit': {
      value: 'wonder-recommend/edit',
      disallow: true,
    },
    'routes.recommendation-management/edit/:id': {
      value: 'wonder-recommend/edit/:id',
      disallow: true,
    },
    'routes.search-results': {
      value: 'search-results',
      disallow: false,
    },
    'routes.category': {
      value: 'category',
      disallow: false,
    },
    'routes.category/:category': {
      value: 'category/:category',
      disallow: false,
    },
    'routes.sharry': {
      value: 'experiences',
      disallow: false,
    },
    'routes.sharries': {
      value: 'experiences',
      disallow: false,
    },
    'routes.sharries/:slug': {
      value: 'sharries/:slug',
      disallow: false,
    },
    'routes.sharries/:slug/instances/:instanceId': {
      value: 'sharries/:slug/set/:instanceId',
      disallow: true,
    },
    'routes.sharry-activity': {
      value: 'activity',
      disallow: true,
    },
    'routes.sharry-activity/bookings': {
      value: 'activity/bookings',
      disallow: true,
    },
    'routes.sharry-activity/messages': {
      value: 'activity/messages',
      disallow: true,
    },
    'routes.sharry-activity/notifications': {
      value: 'activity/notifications',
      disallow: true,
    },
    'routes.sharry-activity/requests': {
      value: 'activity/requests',
      disallow: true,
    },
    'routes.sharry-create': {
      value: 'create-shop',
      disallow: true,
    },
    'routes.signin': {
      value: 'signin',
      disallow: true,
    },
    'routes.terms': {
      value: 'terms',
      disallow: false,
    },
    'routes.trip': {
      value: 'sharryland-trip',
      disallow: false,
    },
    'routes.what-is-sharryland': {
      value: 'what-is-sharryland',
      disallow: false,
    },
    'routes.who-we-are': {
      value: 'who-we-are',
      disallow: false,
    },
    'routes.wonder': {
      value: 'wonders',
      disallow: false,
    },
    'routes.wonders': {
      value: 'wonders',
      disallow: false,
    },
    'routes.wonders/:slug': {
      value: 'wonders/:slug',
      disallow: false,
    },
    'routes.discover': {
      value: 'discover',
      disallow: false,
    },
    'routes.discover/:keyword': {
      value: 'discover/:keyword',
      disallow: false,
    },
    'routes.gift-card': {
      value: 'gift-card',
      disallow: false,
    },
    'routes.added-to-cart': {
      value: 'added-to-cart',
      disallow: true,
    },
    'routes.cart': {
      value: 'cart',
      disallow: true,
    },
    'routes.checkout': {
      value: 'checkout',
      disallow: true,
    },
    'routes.wonders-map': {
      value: 'wonders-map',
      disallow: false,
    },
    'routes.business-trips': {
      value: 'business-trips',
      disallow: false,
    },
    'routes.become-coordinator': {
      value: 'become-coordinator',
      disallow: false,
    },
    'routes.likes/shared/:slug': {
      value: 'my-collection/shared/:slug',
      disallow: false,
    },
    'routes.post-widget/:slug': {
      value: 'post-widget/:slug',
      disallow: false,
    },
  },
  es: {
    'routes.**': {
      value: '**',
      disallow: false,
    },
    'routes.ambassador': {
      value: 'ambassador',
      disallow: false,
    },
    'routes.become-pro': {
      value: 'pasa-a-pro',
      disallow: false,
    },
    'routes.cherry-meter': {
      value: 'medidor-de-cerezas',
      disallow: false,
    },
    'routes.community': {
      value: 'community',
      disallow: false,
    },
    'routes.community/my-posts': {
      value: 'community/mis-publicaciones',
      disallow: true,
    },
    'routes.contacts': {
      value: 'contactos',
      disallow: false,
    },
    'routes.content-not-found': {
      value: 'content-not-found',
      disallow: false,
    },
    'routes.create': {
      value: 'crea',
      disallow: true,
    },
    'routes.create?': {
      value: 'crea?',
      disallow: true,
    },
    'routes.dashboard': {
      value: 'panel-de-control',
      disallow: true,
    },
    'routes.dashboard/bookings': {
      value: 'panel-de-control/reservas',
      disallow: true,
    },
    'routes.dashboard/calendar': {
      value: 'panel-de-control/calendario',
      disallow: true,
    },
    'routes.dashboard/user-carts': {
      value: 'dashboard/user-carts',
      disallow: true,
    },
    'routes.dashboard/custom-requests': {
      value: 'panel-de.control/instancias-personalizadas',
      disallow: true,
    },
    'routes.dashboard/messages': {
      value: 'panel-de-control/mensajes',
      disallow: true,
    },
    'routes.dashboard/notifications': {
      value: 'panel-de-control/notificaciones',
      disallow: true,
    },
    'routes.dashboard/sharry-management': {
      value: 'panel-de-control/gestion-experiencias',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit': {
      value: 'panel-de-control/gestion-experiencias/modificar',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit/:id': {
      value: 'panel-de-control/gestion-experiencias/modificar/:id',
      disallow: true,
    },
    'routes.deprecated': {
      value: 'deprecated',
      disallow: false,
    },
    'routes.edit': {
      value: 'modifica',
      disallow: true,
    },
    'routes.event-dashboard': {
      value: 'eventos-panel-de-control',
      disallow: true,
    },
    'routes.event-dashboard/events-calendar': {
      value: 'eventos-panel-de-control/eventos-calendario',
      disallow: true,
    },
    'routes.event-dashboard/events-report': {
      value: 'eventos-panel-de-control/recomienda-eventos',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit': {
      value: 'eventos-panel-de-control/recomienda-eventos/modificar',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit/:id': {
      value: 'eventos-panel-de-control/recomienda-eventos/modificar/:id',
      disallow: true,
    },
    'routes.event': {
      value: 'eventos',
      disallow: false,
    },
    'routes.events': {
      value: 'eventos',
      disallow: false,
    },
    'routes.events/:slug': {
      value: 'eventos/:slug',
      disallow: false,
    },
    'routes.explore': {
      value: 'explora',
      disallow: false,
    },
    'routes.faq': {
      value: 'ayuda',
      disallow: false,
    },
    'routes.find/events-at': {
      value: 'busca/eventos-en-ciudad',
      disallow: false,
    },
    'routes.find/events-at/:location': {
      value: 'busca/eventos-en-ciudad/:location',
      disallow: false,
    },
    'routes.find/events-in': {
      value: 'busca/eventos-en-region',
      disallow: false,
    },
    'routes.find/events-in/:location': {
      value: 'busca/eventos-en-region/:location',
      disallow: false,
    },
    'routes.find/what-to-do-at': {
      value: 'busca/que-hacer-en-ciudad',
      disallow: false,
    },
    'routes.find/what-to-do-at/:location': {
      value: 'busca/que-hacer-en-ciudad/:location',
      disallow: false,
    },
    'routes.find/what-to-do-near': {
      value: 'busca/que-hacer-cerca-de',
      disallow: false,
    },
    'routes.find/what-to-do-near/:location': {
      value: 'busca/que-hacer-cerca-de/:location',
      disallow: false,
    },
    'routes.find/what-to-do-in': {
      value: 'busca/que-hacer-en-region',
      disallow: false,
    },
    'routes.find/what-to-do-in/:location': {
      value: 'busca/que-hacer-en-region/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-at': {
      value: 'busca/que-visitar-en-ciudad',
      disallow: false,
    },
    'routes.find/what-to-visit-at/:location': {
      value: 'busca/que-visitar-en-ciudad/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-in': {
      value: 'busca/que-visitar-en-region',
      disallow: false,
    },
    'routes.find/what-to-visit-in/:location': {
      value: 'busca/que-visitar-en-region/:location',
      disallow: false,
    },
    'routes.go': {
      value: 'go',
      disallow: false,
    },
    'routes.go/:slug': {
      value: 'go/:slug',
      disallow: false,
    },
    'routes.instances': {
      value: 'set',
      disallow: true,
    },
    'routes.land': {
      value: 'land',
      disallow: false,
    },
    'routes.like': {
      value: 'mis-colecciones',
      disallow: true,
    },
    'routes.likes': {
      value: 'mis-colecciones',
      disallow: true,
    },
    'routes.likes/default': {
      value: 'mis-colecciones/default',
      disallow: true,
    },
    'routes.maintenance': {
      value: 'maintenance',
      disallow: false,
    },
    'routes.messages': {
      value: 'mensajes',
      disallow: true,
    },
    'routes.network': {
      value: 'red',
      disallow: true,
    },
    'routes.not-found': {
      value: 'not-found',
      disallow: false,
    },
    'routes.not-implemented': {
      value: 'no-implementado',
      disallow: false,
    },
    'routes.notifications': {
      value: 'notificaciones',
      disallow: true,
    },
    'routes.privacy': {
      value: 'privacy',
      disallow: false,
    },
    'routes.selling-conditions': {
      value: 'condiciones-venta',
      disallow: false,
    },
    'routes.profile': {
      value: 'perfil',
      disallow: false,
    },
    'routes.profile/:slug': {
      value: 'perfil/:slug',
      disallow: false,
    },
    'routes.profile/home': {
      value: 'perfil/home',
      disallow: true,
    },
    'routes.recommendation-create-introduction': {
      value: 'nuevo-contenido-informaciones',
      disallow: false,
    },
    'routes.recommendation-management': {
      value: 'recomienda-maravillas',
      disallow: true,
    },
    'routes.recommendation-management/edit': {
      value: 'recomienda-maravillas/modifica',
      disallow: true,
    },
    'routes.recommendation-management/edit/:id': {
      value: 'recomienda-maravillas/modifica/:id',
      disallow: true,
    },
    'routes.search-results': {
      value: 'resultados',
      disallow: false,
    },
    'routes.category': {
      value: 'clase',
      disallow: false,
    },
    'routes.category/:category': {
      value: 'clase/:category',
      disallow: false,
    },
    'routes.sharry': {
      value: 'experiencias',
      disallow: false,
    },
    'routes.sharries': {
      value: 'experiencias',
      disallow: false,
    },
    'routes.sharries/:slug': {
      value: 'experiencias/:slug',
      disallow: false,
    },
    'routes.sharries/:slug/instances/:instanceId': {
      value: 'experiencias/:slug/set/:instanceld',
      disallow: true,
    },
    'routes.sharry-activity': {
      value: 'experiencia-actividad',
      disallow: true,
    },
    'routes.sharry-activity/bookings': {
      value: 'experiencia-actividad/reservas',
      disallow: true,
    },
    'routes.sharry-activity/messages': {
      value: 'experinecia-actividad/mensages',
      disallow: true,
    },
    'routes.sharry-activity/notifications': {
      value: 'experiencia-actividad/notificaciones',
      disallow: true,
    },
    'routes.sharry-activity/requests': {
      value: 'experiencia-actividad/demandas',
      disallow: true,
    },
    'routes.sharry-create': {
      value: 'crea-shop',
      disallow: true,
    },
    'routes.signin': {
      value: 'signin',
      disallow: true,
    },
    'routes.terms': {
      value: 'condiciones',
      disallow: false,
    },
    'routes.trip': {
      value: 'sharryland-viajes',
      disallow: false,
    },
    'routes.what-is-sharryland': {
      value: 'que-es-sharryland',
      disallow: false,
    },
    'routes.who-we-are': {
      value: 'quienes-somos',
      disallow: false,
    },
    'routes.wonder': {
      value: 'maravillas',
      disallow: false,
    },
    'routes.wonders': {
      value: 'maravillas',
      disallow: false,
    },
    'routes.wonders/:slug': {
      value: 'maravillas/:slug',
      disallow: false,
    },
    'routes.discover': {
      value: 'descubra',
      disallow: false,
    },
    'routes.discover/:keyword': {
      value: 'descubra/:keyword',
      disallow: false,
    },
    'routes.gift-card': {
      value: 'gift-card',
      disallow: false,
    },
    'routes.added-to-cart': {
      value: 'añadido-a-la-cesta',
      disallow: true,
    },
    'routes.cart': {
      value: 'cart',
      disallow: true,
    },
    'routes.checkout': {
      value: 'checkout',
      disallow: true,
    },
    'routes.wonders-map': {
      value: 'mapa-de-maravillas',
      disallow: false,
    },
    'routes.business-trips': {
      value: 'viajes-para-empresas',
      disallow: false,
    },
    'routes.become-coordinator': {
      value: 'convertirse-en-coordinador',
      disallow: false,
    },
    'routes.likes/shared/:slug': {
      value: 'mis-colecciones/compartido/:slug',
      disallow: true,
    },
    'routes.post-widget/:slug': {
      value: 'post-widget/:slug',
      disallow: false,
    },
  },
  fr: {
    'routes.**': {
      value: '**',
      disallow: false,
    },
    'routes.ambassador': {
      value: 'ambassador',
      disallow: false,
    },
    'routes.become-pro': {
      value: 'devenir-pro',
      disallow: false,
    },
    'routes.cherry-meter': {
      value: 'compteur-de-cerises',
      disallow: false,
    },
    'routes.community': {
      value: 'community',
      disallow: false,
    },
    'routes.community/my-posts': {
      value: 'community/my-posts',
      disallow: true,
    },
    'routes.contacts': {
      value: 'contactez-nous',
      disallow: false,
    },
    'routes.content-not-found': {
      value: 'content-not-found',
      disallow: false,
    },
    'routes.create': {
      value: 'creer',
      disallow: true,
    },
    'routes.create?': {
      value: 'creer?',
      disallow: true,
    },
    'routes.dashboard': {
      value: 'bureau',
      disallow: true,
    },
    'routes.dashboard/bookings': {
      value: 'bureau/reservations',
      disallow: true,
    },
    'routes.dashboard/calendar': {
      value: 'bureau/calendrier',
      disallow: true,
    },
    'routes.dashboard/user-carts': {
      value: 'dashboard/user-carts',
      disallow: true,
    },
    'routes.dashboard/custom-requests': {
      value: 'bureau/demandes-personnalisee',
      disallow: true,
    },
    'routes.dashboard/messages': {
      value: 'bureau/messages',
      disallow: true,
    },
    'routes.dashboard/notifications': {
      value: 'bureau/notifications',
      disallow: true,
    },
    'routes.dashboard/sharry-management': {
      value: 'bureau/activites-gestion',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit': {
      value: 'bureau/activites-gestion/modifier',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit/:id': {
      value: 'bureau/activites-gestion/modifier/:id',
      disallow: true,
    },
    'routes.deprecated': {
      value: 'deprecated',
      disallow: false,
    },
    'routes.edit': {
      value: 'modifier',
      disallow: true,
    },
    'routes.event-dashboard': {
      value: 'evenements-bureau',
      disallow: true,
    },
    'routes.event-dashboard/events-calendar': {
      value: 'evenements-bureau/calendrier-evenements',
      disallow: true,
    },
    'routes.event-dashboard/events-report': {
      value: 'evenements-bureau/signaler-evenements',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit': {
      value: 'evenements-bureau/signaler-evenements/modifier',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit/:id': {
      value: 'evenements-bureau/signaler-evenements/modifier/:id',
      disallow: true,
    },
    'routes.event': {
      value: 'evenements',
      disallow: false,
    },
    'routes.events': {
      value: 'evenements',
      disallow: false,
    },
    'routes.events/:slug': {
      value: 'evenements/:slug',
      disallow: false,
    },
    'routes.explore': {
      value: 'explorer',
      disallow: false,
    },
    'routes.faq': {
      value: 'aide',
      disallow: false,
    },
    'routes.find/events-at': {
      value: 'trouvez/evenements-a',
      disallow: false,
    },
    'routes.find/events-at/:location': {
      value: 'trouvez/evenements-a/:location',
      disallow: false,
    },
    'routes.find/events-in': {
      value: 'trouvez/evenements-en',
      disallow: false,
    },
    'routes.find/events-in/:location': {
      value: 'trouvez/evenements-en/:location',
      disallow: false,
    },
    'routes.find/what-to-do-at': {
      value: 'trouvez/quoi-faire-a',
      disallow: false,
    },
    'routes.find/what-to-do-at/:location': {
      value: 'trouvez/quoi-faire-a/:location',
      disallow: false,
    },
    'routes.find/what-to-do-near': {
      value: 'trouvez/quoi-faire-pres-de',
      disallow: false,
    },
    'routes.find/what-to-do-near/:location': {
      value: 'trouvez/quoi-faire-pres-de/:location',
      disallow: false,
    },
    'routes.find/what-to-do-in': {
      value: 'trouvez/quoi-faire-en',
      disallow: false,
    },
    'routes.find/what-to-do-in/:location': {
      value: 'trouvez/quoi-faire-en/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-at': {
      value: 'trouvez/quoi-visiter-a',
      disallow: false,
    },
    'routes.find/what-to-visit-at/:location': {
      value: 'trouvez/quoi-visiter-a/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-in': {
      value: 'trouvez/quoi-visiter-en',
      disallow: false,
    },
    'routes.find/what-to-visit-in/:location': {
      value: 'trouvez/quoi-visiter-en/:location',
      disallow: false,
    },
    'routes.go': {
      value: 'go',
      disallow: false,
    },
    'routes.go/:slug': {
      value: 'go/:slug',
      disallow: false,
    },
    'routes.instances': {
      value: 'set',
      disallow: true,
    },
    'routes.land': {
      value: 'land',
      disallow: false,
    },
    'routes.like': {
      value: 'mes-collections/',
      disallow: true,
    },
    'routes.likes': {
      value: 'mes-collections',
      disallow: true,
    },
    'routes.likes/default': {
      value: 'mes-collections/default',
      disallow: true,
    },
    'routes.maintenance': {
      value: 'maintenance',
      disallow: false,
    },
    'routes.messages': {
      value: 'messages',
      disallow: true,
    },
    'routes.network': {
      value: 'network',
      disallow: true,
    },
    'routes.not-found': {
      value: 'not-found',
      disallow: false,
    },
    'routes.not-implemented': {
      value: 'pas-disponible',
      disallow: false,
    },
    'routes.notifications': {
      value: 'notifications',
      disallow: true,
    },
    'routes.privacy': {
      value: 'privacy',
      disallow: false,
    },
    'routes.selling-conditions': {
      value: 'conditions-vente',
      disallow: false,
    },
    'routes.profile': {
      value: 'profil',
      disallow: false,
    },
    'routes.profile/:slug': {
      value: 'profil/:slug',
      disallow: false,
    },
    'routes.profile/home': {
      value: 'profil/accueil',
      disallow: true,
    },
    'routes.recommendation-create-introduction': {
      value: 'nouveau-contenu-informations',
      disallow: false,
    },
    'routes.recommendation-management': {
      value: 'recommande-merveille',
      disallow: true,
    },
    'routes.recommendation-management/edit': {
      value: 'recommande-merveille/modifier',
      disallow: true,
    },
    'routes.recommendation-management/edit/:id': {
      value: 'recommande-merveille/modifier/:id',
      disallow: true,
    },
    'routes.search-results': {
      value: 'resultats',
      disallow: false,
    },
    'routes.category': {
      value: 'categorie',
      disallow: false,
    },
    'routes.category/:category': {
      value: 'categorie/:category',
      disallow: false,
    },
    'routes.sharry': {
      value: 'activites',
      disallow: false,
    },
    'routes.sharries': {
      value: 'activites',
      disallow: false,
    },
    'routes.sharries/:slug': {
      value: 'activites/:slug',
      disallow: false,
    },
    'routes.sharries/:slug/instances/:instanceId': {
      value: 'activites/:slug/set/:instanceId',
      disallow: true,
    },
    'routes.sharry-activity': {
      value: 'mon-espace-client',
      disallow: true,
    },
    'routes.sharry-activity/bookings': {
      value: 'mon-espace-client/mes-reservations',
      disallow: true,
    },
    'routes.sharry-activity/messages': {
      value: 'mon-espace-client/mes-messages',
      disallow: true,
    },
    'routes.sharry-activity/notifications': {
      value: 'mon-espace-client/mes-notifications',
      disallow: true,
    },
    'routes.sharry-activity/requests': {
      value: 'mon-espace-client/mes-demandes',
      disallow: true,
    },
    'routes.sharry-create': {
      value: 'creer-shop',
      disallow: true,
    },
    'routes.signin': {
      value: 'signin',
      disallow: true,
    },
    'routes.terms': {
      value: 'conditions',
      disallow: false,
    },
    'routes.trip': {
      value: 'sharryland-voyager',
      disallow: false,
    },
    'routes.what-is-sharryland': {
      value: 'a-propos-de-sharryland',
      disallow: false,
    },
    'routes.who-we-are': {
      value: 'qui-sommes-nous',
      disallow: false,
    },
    'routes.wonder': {
      value: 'merveilles',
      disallow: false,
    },
    'routes.wonders': {
      value: 'merveilles',
      disallow: false,
    },
    'routes.wonders/:slug': {
      value: 'merveilles/:slug',
      disallow: false,
    },
    'routes.discover': {
      value: 'decouvrir',
      disallow: false,
    },
    'routes.discover/:keyword': {
      value: 'decouvrir/:keyword',
      disallow: false,
    },
    'routes.gift-card': {
      value: 'gift-card',
      disallow: false,
    },
    'routes.added-to-cart': {
      value: 'ajouté-au-panier',
      disallow: true,
    },
    'routes.cart': {
      value: 'cart',
      disallow: true,
    },
    'routes.checkout': {
      value: 'checkout',
      disallow: true,
    },
    'routes.wonders-map': {
      value: 'carte-des-merveilles',
      disallow: false,
    },
    'routes.business-trips': {
      value: 'voyages-pour-entreprises',
      disallow: false,
    },
    'routes.become-coordinator': {
      value: 'devenir-coordinateur',
      disallow: false,
    },
    'routes.likes/shared/:slug': {
      value: 'my-collection/commun/:slug',
      disallow: true,
    },
    'routes.post-widget/:slug': {
      value: 'post-widget/:slug',
      disallow: false,
    },
  },
  de: {
    'routes.**': {
      value: '**',
      disallow: false,
    },
    'routes.ambassador': {
      value: 'ambassador',
      disallow: false,
    },
    'routes.become-pro': {
      value: 'zu-pro-werden',
      disallow: false,
    },
    'routes.cherry-meter': {
      value: 'kirschenmeter',
      disallow: false,
    },
    'routes.community': {
      value: 'community',
      disallow: false,
    },
    'routes.community/my-posts': {
      value: 'community/meine-posts',
      disallow: true,
    },
    'routes.contacts': {
      value: 'kontakt',
      disallow: false,
    },
    'routes.content-not-found': {
      value: 'content-not-found',
      disallow: false,
    },
    'routes.create': {
      value: 'kreieren',
      disallow: true,
    },
    'routes.create?': {
      value: 'kreieren?',
      disallow: true,
    },
    'routes.dashboard': {
      value: 'dashboard',
      disallow: true,
    },
    'routes.dashboard/bookings': {
      value: 'dashboard/reservierungen',
      disallow: true,
    },
    'routes.dashboard/calendar': {
      value: 'dashboard/kalender',
      disallow: true,
    },
    'routes.dashboard/user-carts': {
      value: 'dashboard/user-carts',
      disallow: true,
    },
    'routes.dashboard/custom-requests': {
      value: 'dashboard/kundenanfragen',
      disallow: true,
    },
    'routes.dashboard/messages': {
      value: 'dashboard/nachrichten',
      disallow: true,
    },
    'routes.dashboard/notifications': {
      value: 'dashboard/benachrichtigungen',
      disallow: true,
    },
    'routes.dashboard/sharry-management': {
      value: 'dashboard/organisation-erfahrungen',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit': {
      value: 'dashboard/organisation-erfahrungen/bearbeiten',
      disallow: true,
    },
    'routes.dashboard/sharry-management/edit/:id': {
      value: 'dashboard/organisation-erfahrungen/bearbeiten/:id',
      disallow: true,
    },
    'routes.deprecated': {
      value: 'deprecated',
      disallow: false,
    },
    'routes.edit': {
      value: 'bearbeiten',
      disallow: true,
    },
    'routes.event-dashboard': {
      value: 'dashboard-events',
      disallow: true,
    },
    'routes.event-dashboard/events-calendar': {
      value: 'dashboard-events/kalender-events',
      disallow: true,
    },
    'routes.event-dashboard/events-report': {
      value: 'dashboard-events/signalisiere-events',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit': {
      value: 'dashboard-events/signalisiere-events/bearbeite',
      disallow: true,
    },
    'routes.event-dashboard/events-report/edit/:id': {
      value: 'dashboard-events/signalisiere-events/bearbeite/:id',
      disallow: true,
    },
    'routes.event': {
      value: 'events',
      disallow: false,
    },
    'routes.events': {
      value: 'events',
      disallow: false,
    },
    'routes.events/:slug': {
      value: 'events/:slug',
      disallow: false,
    },
    'routes.explore': {
      value: 'erkunden',
      disallow: false,
    },
    'routes.faq': {
      value: 'hilfe',
      disallow: false,
    },
    'routes.find/events-at': {
      value: 'finden/veranstaltungen-at',
      disallow: false,
    },
    'routes.find/events-at/:location': {
      value: 'finden/veranstaltungen-at/:location',
      disallow: false,
    },
    'routes.find/events-in': {
      value: 'finden/veranstaltungen-in',
      disallow: false,
    },
    'routes.find/events-in/:location': {
      value: 'finden/veranstaltungen-in/:location',
      disallow: false,
    },
    'routes.find/what-to-do-at': {
      value: 'finden/was-machen-at',
      disallow: false,
    },
    'routes.find/what-to-do-at/:location': {
      value: 'finden/was-machen-at/:location',
      disallow: false,
    },
    'routes.find/what-to-do-near': {
      value: 'finden/was-machen-in-der-nahe',
      disallow: false,
    },
    'routes.find/what-to-do-near/:location': {
      value: 'finden/was-machen-in-der-nahe/:location',
      disallow: false,
    },
    'routes.find/what-to-do-in': {
      value: 'finden/was-machen-in',
      disallow: false,
    },
    'routes.find/what-to-do-in/:location': {
      value: 'finden/was-machen-in/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-at': {
      value: 'finden/was-sehen-at',
      disallow: false,
    },
    'routes.find/what-to-visit-at/:location': {
      value: 'finden/was-sehen-at/:location',
      disallow: false,
    },
    'routes.find/what-to-visit-in': {
      value: 'finden/was-sehen-in',
      disallow: false,
    },
    'routes.find/what-to-visit-in/:location': {
      value: 'finden/was-sehen-in/:location',
      disallow: false,
    },
    'routes.go': {
      value: 'go',
      disallow: false,
    },
    'routes.go/:slug': {
      value: 'go/:slug',
      disallow: false,
    },
    'routes.instances': {
      value: 'set',
      disallow: true,
    },
    'routes.land': {
      value: 'land',
      disallow: false,
    },
    'routes.like': {
      value: 'meine-sammlungen/',
      disallow: true,
    },
    'routes.likes': {
      value: 'meine-sammlungen',
      disallow: true,
    },
    'routes.likes/default': {
      value: 'meine-sammlungen/default',
      disallow: true,
    },
    'routes.maintenance': {
      value: 'maintenance',
      disallow: false,
    },
    'routes.messages': {
      value: 'nachrichten',
      disallow: true,
    },
    'routes.network': {
      value: 'netzwerk',
      disallow: true,
    },
    'routes.not-found': {
      value: 'not-found',
      disallow: false,
    },
    'routes.not-implemented': {
      value: 'nicht-verfugbar',
      disallow: false,
    },
    'routes.notifications': {
      value: 'benachrichtigungen',
      disallow: true,
    },
    'routes.privacy': {
      value: 'privacy',
      disallow: false,
    },
    'routes.selling-conditions': {
      value: 'verkaufsbedingungen',
      disallow: false,
    },
    'routes.profile': {
      value: 'profil',
      disallow: false,
    },
    'routes.profile/:slug': {
      value: 'profil/:slug',
      disallow: false,
    },
    'routes.profile/home': {
      value: 'profil/home',
      disallow: true,
    },
    'routes.recommendation-create-introduction': {
      value: 'neuer-inhalt-informationen',
      disallow: false,
    },
    'routes.recommendation-management': {
      value: 'wunder-empfehlen',
      disallow: true,
    },
    'routes.recommendation-management/edit': {
      value: 'empfehlen/wunder-bearbeiten',
      disallow: true,
    },
    'routes.recommendation-management/edit/:id': {
      value: 'empfehlen/wunder-bearbeiten/:id',
      disallow: true,
    },
    'routes.search-results': {
      value: 'ergebnisse-suchen',
      disallow: false,
    },
    'routes.category': {
      value: 'kategorie',
      disallow: false,
    },
    'routes.category/:category': {
      value: 'kategorie/:category',
      disallow: false,
    },
    'routes.sharry': {
      value: 'erfahrungen',
      disallow: false,
    },
    'routes.sharries': {
      value: 'erfahrungen',
      disallow: false,
    },
    'routes.sharries/:slug': {
      value: 'erfahrungen/:slug',
      disallow: false,
    },
    'routes.sharries/:slug/instances/:instanceId': {
      value: 'erfahrungen/:slug/set/:instanceld',
      disallow: true,
    },
    'routes.sharry-activity': {
      value: 'aktivitaten',
      disallow: true,
    },
    'routes.sharry-activity/bookings': {
      value: 'aktivitaten/reservierungen',
      disallow: true,
    },
    'routes.sharry-activity/messages': {
      value: 'aktivitaten/nachrichten',
      disallow: true,
    },
    'routes.sharry-activity/notifications': {
      value: 'aktivitaten/benachrichtigungen',
      disallow: true,
    },
    'routes.sharry-activity/requests': {
      value: 'aktivitaten/anfragen',
      disallow: true,
    },
    'routes.sharry-create': {
      value: 'kreieren-shop',
      disallow: true,
    },
    'routes.signin': {
      value: 'signin',
      disallow: true,
    },
    'routes.terms': {
      value: 'konditionen',
      disallow: false,
    },
    'routes.trip': {
      value: 'sharryland-reise',
      disallow: false,
    },
    'routes.what-is-sharryland': {
      value: 'was-ist-sharryland',
      disallow: false,
    },
    'routes.who-we-are': {
      value: 'wer-wir-sind',
      disallow: false,
    },
    'routes.wonder': {
      value: 'wunder',
      disallow: false,
    },
    'routes.wonders': {
      value: 'wunder',
      disallow: false,
    },
    'routes.wonders/:slug': {
      value: 'wunder/:slug',
      disallow: false,
    },
    'routes.discover': {
      value: 'entdecken',
      disallow: false,
    },
    'routes.discover/:keyword': {
      value: 'entdecken/:keyword',
      disallow: false,
    },
    'routes.gift-card': {
      value: 'gift-card',
      disallow: false,
    },
    'routes.added-to-cart': {
      value: 'in-den-einkaufswagen-gelegt',
      disallow: true,
    },
    'routes.cart': {
      value: 'cart',
      disallow: true,
    },
    'routes.checkout': {
      value: 'checkout',
      disallow: true,
    },
    'routes.wonders-map': {
      value: 'wunderkarte',
      disallow: false,
    },
    'routes.business-trips': {
      value: 'reisen-fur-unternehmen',
      disallow: false,
    },
    'routes.become-coordinator': {
      value: 'koordinator-werden',
      disallow: false,
    },
    'routes.likes/shared/:slug': {
      value: 'meine-sammlungen/geteilt/:slug',
      disallow: true,
    },
    'routes.post-widget/:slug': {
      value: 'post-widget/:slug',
      disallow: false,
    },
  },
};

export const routes = {
  it: Object.fromEntries(Object.entries(serverRoutes.it).map(([key, { value }]) => [key, value])),
  en: Object.fromEntries(Object.entries(serverRoutes.en).map(([key, { value }]) => [key, value])),
  es: Object.fromEntries(Object.entries(serverRoutes.es).map(([key, { value }]) => [key, value])),
  fr: Object.fromEntries(Object.entries(serverRoutes.fr).map(([key, { value }]) => [key, value])),
  de: Object.fromEntries(Object.entries(serverRoutes.de).map(([key, { value }]) => [key, value])),
};

export const disallowedRoutes = [
  ...Object.values(serverRoutes.it)
    .filter(r => !!r.disallow)
    .map(r => '/it/' + r.value),
  ...Object.values(serverRoutes.en)
    .filter(r => !!r.disallow)
    .map(r => '/en/' + r.value),
  ...Object.values(serverRoutes.es)
    .filter(r => !!r.disallow)
    .map(r => '/es/' + r.value),
  ...Object.values(serverRoutes.fr)
    .filter(r => !!r.disallow)
    .map(r => '/fr/' + r.value),
  ...Object.values(serverRoutes.de)
    .filter(r => !!r.disallow)
    .map(r => '/de/' + r.value),
];

// const indexes: number[] = [];
// Object.fromEntries(
//   Object.entries({}).map(([key, { value, disallow }], i) => {
//     if (indexes.includes(i)) {
//       return [key, { value, disallow: true }];
//     } else {
//       return [key, { value, disallow: false }];
//     }
//   }),
// );
